import React, { useEffect, useState, useCallback, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import './side.css'

const Language = "English";

export default function Menubar() {
    const API_BASE =
        process.env.REACT_APP_API_BASE || "http://13.127.67.252:5040";

    const [userMenuDetails, setUserMenuDetails] = useState([]);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [activeBgId, setActiveBgId] = useState(null);
    const [openFlyoutId, setOpenFlyoutId] = useState(null);
    const [expandedAccordion, setExpandedAccordion] = useState(null);

    const sidebarRef = useRef(null)
    useEffect(() => {
        const handleClickOutSide = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsCollapsed(!isCollapsed)
                setOpenFlyoutId(null)
            }
        }
        document.addEventListener('mousedown', handleClickOutSide)

        return () => {
            document.removeEventListener('mousedown', handleClickOutSide)
        }
    }, [])

    // ✅ API CALL
    const firstMenuLoad = useCallback(async () => {
        try {
            const res = await fetch(`${API_BASE}/FP23S3/`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    data: { p5: 1, p21: 1, p22: 10, p23: "AdminUserMenuID", p26: 1, p27: 1 },
                }),
            });

            const result = await res.json();
            const {
                Output: {
                    status: { code },
                    data,
                },
            } = result;

            if (code == "200") {
                let newMenu = [];

                data.forEach((val) => {
                    if (val.MenuOrder == "1") {
                        let sub1 = [];

                        data.forEach((val2) => {
                            if (val.MenuID === val2.ParentMenu) {
                                sub1.push({
                                    ...val2,
                                    Sub2: data.filter((x) => x.ParentMenu === val2.MenuID),
                                });
                            }
                        });

                        newMenu.push({ ...val, Sub1: sub1 });
                    }
                });

                setUserMenuDetails(newMenu);
            }
        } catch (err) {
            console.error(err);
        }
    }, [API_BASE]);

    useEffect(() => {
        firstMenuLoad();
    }, [firstMenuLoad]);

    // ✅ HANDLERS
    const handleMenuClick = (menuId) => {
        setActiveBgId(menuId);
        setOpenFlyoutId(menuId);
        setIsCollapsed(false);
    };

    const toggleAccordion = (id) => {
        setExpandedAccordion(expandedAccordion === id ? null : id);
    };

    return (
        <div className="flex font-family" ref={sidebarRef}>
            {/* ✅ SIDEBAR */}
            <div
                className={`h-screen overflow-y-auto overflow-x-hidden bg-blue-500 text-white transition-all duration-300 ${isCollapsed ? "w-14 justify-center" : "w-52"
                    }`}
            >
                {/* Toggle */}
                <div className="p-2">
                    <button
                        onClick={() => {
                            setIsCollapsed(prev => !prev);
                            if (openFlyoutId) {
                                setOpenFlyoutId(null);
                            }
                        }}
                        className="bg-gray-800 p-2 rounded w-full"
                    >
                        ☰
                    </button>
                </div>

                {/* Menu */}
                <ul className="mt-2 space-y-1">
                    {userMenuDetails.map((menu) => (
                        <li key={menu.MenuID}>
                            <div
                                onClick={() => handleMenuClick(menu.MenuID)}
                                className={`flex items-center gap-3 px-3 py-2 cursor-pointer rounded-l-lg hover:bg-gray-700
                  ${activeBgId === menu.MenuID ? "bg-gray-700" : ""}`}
                            >
                                <Tooltip title={menu.MenuDisplayName} placement="right">
                                    <img
                                        src={`${API_BASE}/Images/assets/CommonIcons/${menu.MenuIconFont}.png`}
                                        alt=""
                                        className="w-5 h-5"
                                    />
                                </Tooltip>

                                {!isCollapsed && (
                                    <span className="text-sm">
                                        {Language === "English"
                                            ? menu.MenuDisplayName
                                            : menu.ImportIcoRef}
                                    </span>
                                )}
                            </div>

                            {/* ✅ FLYOUT */}
                            {openFlyoutId === menu.MenuID && (
                                <div className="fixed left-52 top-0 h-screen w-64 bg-white text-black shadow-lg overflow-y-auto">
                                    {menu.Sub1.map((sub1) => (
                                        <div key={sub1.MenuID} className="border-b">
                                            {/* Accordion Header */}
                                            <div
                                                onClick={() => toggleAccordion(sub1.MenuID)}
                                                className="flex justify-between items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                                            >
                                                <span className="text-sm font-medium">
                                                    {sub1.MenuDisplayName}
                                                </span>

                                                {expandedAccordion === sub1.MenuID ? (
                                                    <ExpandLessIcon />
                                                ) : (
                                                    <ExpandMoreIcon />
                                                )}
                                            </div>

                                            {/* Sub2 */}
                                            {expandedAccordion === sub1.MenuID && (
                                                <div className="pl-6">
                                                    {sub1.Sub2.map((sub2) => (
                                                        <div
                                                            key={sub2.MenuID}
                                                            className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                                                        >
                                                            <Icon className="text-sm">
                                                                {sub2.MenuIconFont}
                                                            </Icon>
                                                            {sub2.MenuDisplayName}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}